// extracted by mini-css-extract-plugin
module.exports = {"dot":"styles_dot__1nLLP","isActive":"styles_isActive__1eu4V","isDisabled":"styles_isDisabled__2FKMe"};